import script from "./ChangeLanguage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeLanguage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import qInstall from "../../node_modules/.pnpm/@quasar+app-webpack@3.11.3__19fadae530b491e33818dbf1a8400ef1/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown});
